<template>
  <div class="left">
    <session-navbar :countDown="null" :name="null" :localtime="null" />
    <div style="height: 100px"></div>

    <div class="content-left">
      <h3 class="title">You left the session.</h3>

      <button class="rejoin" @click="rejoinSession">
        <svg
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.2768 8.64778C31.7209 8.87632 32 9.33389 32 9.83334V23.1667C32 23.6661 31.7209 24.1237 31.2768 24.3522C30.8327 24.5808 30.2981 24.542 29.8917 24.2517L20.5583 17.585C20.208 17.3347 20 16.9306 20 16.5C20 16.0694 20.208 15.6653 20.5583 15.415L29.8917 8.74836C30.2981 8.45806 30.8327 8.41924 31.2768 8.64778ZM23.6273 16.5L29.3333 20.5758V12.4243L23.6273 16.5Z"
            fill="var(--theme-color)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4 8.49999C3.26362 8.49999 2.66667 9.09695 2.66667 9.83333V23.1667C2.66667 23.903 3.26362 24.5 4 24.5H18.6667C19.403 24.5 20 23.903 20 23.1667V9.83333C20 9.09695 19.403 8.49999 18.6667 8.49999H4ZM0 9.83333C0 7.62419 1.79086 5.83333 4 5.83333H18.6667C20.8758 5.83333 22.6667 7.62419 22.6667 9.83333V23.1667C22.6667 25.3758 20.8758 27.1667 18.6667 27.1667H4C1.79086 27.1667 0 25.3758 0 23.1667V9.83333Z"
            fill="var(--theme-color)"
          />
        </svg>
        Rejoin Session
      </button>

      <div class="rating">
        <div class="rating-box">
          <h5>How was the video and audio?</h5>
          <svg
            width="232"
            height="40"
            viewBox="0 0 232 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              @click="selectFirstOne"
              id="firstOne"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.0004 1.66667C20.6347 1.66667 21.2141 2.02679 21.4949 2.59563L26.2575 12.2441L36.9081 13.8009C37.5357 13.8926 38.0568 14.3326 38.2524 14.9359C38.4481 15.5393 38.2843 16.2014 37.8299 16.6439L30.1246 24.1489L31.9431 34.7516C32.0503 35.3769 31.7932 36.0089 31.2799 36.3818C30.7666 36.7546 30.0861 36.8038 29.5246 36.5085L20.0004 31.4997L10.4761 36.5085C9.9146 36.8038 9.23411 36.7546 8.72082 36.3818C8.20752 36.0089 7.95045 35.3769 8.05769 34.7516L9.87617 24.1489L2.17082 16.6439C1.71646 16.2014 1.55267 15.5393 1.7483 14.9359C1.94393 14.3326 2.46506 13.8926 3.09266 13.8009L13.7433 12.2441L18.5059 2.59563C18.7866 2.02679 19.366 1.66667 20.0004 1.66667Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectFirstTwo"
              id="firstTwo"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M68.0004 1.66667C68.6347 1.66667 69.2141 2.02679 69.4949 2.59563L74.2575 12.2441L84.9081 13.8009C85.5357 13.8926 86.0568 14.3326 86.2524 14.9359C86.4481 15.5393 86.2843 16.2014 85.8299 16.6439L78.1246 24.1489L79.9431 34.7516C80.0503 35.3769 79.7932 36.0089 79.2799 36.3818C78.7666 36.7546 78.0861 36.8038 77.5246 36.5085L68.0004 31.4997L58.4761 36.5085C57.9146 36.8038 57.2341 36.7546 56.7208 36.3818C56.2075 36.0089 55.9504 35.3769 56.0577 34.7516L57.8762 24.1489L50.1708 16.6439C49.7165 16.2014 49.5527 15.5393 49.7483 14.9359C49.9439 14.3326 50.4651 13.8926 51.0927 13.8009L61.7433 12.2441L66.5059 2.59563C66.7866 2.02679 67.366 1.66667 68.0004 1.66667Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectFirstThree"
              id="firstThree"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M116 1.66667C116.635 1.66667 117.214 2.02679 117.495 2.59563L122.257 12.2441L132.908 13.8009C133.536 13.8926 134.057 14.3326 134.252 14.9359C134.448 15.5393 134.284 16.2014 133.83 16.6439L126.125 24.1489L127.943 34.7516C128.05 35.3769 127.793 36.0089 127.28 36.3818C126.767 36.7546 126.086 36.8038 125.525 36.5085L116 31.4997L106.476 36.5085C105.915 36.8038 105.234 36.7546 104.721 36.3818C104.208 36.0089 103.95 35.3769 104.058 34.7516L105.876 24.1489L98.1708 16.6439C97.7165 16.2014 97.5527 15.5393 97.7483 14.9359C97.9439 14.3326 98.4651 13.8926 99.0927 13.8009L109.743 12.2441L114.506 2.59563C114.787 2.02679 115.366 1.66667 116 1.66667Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectFirstFour"
              id="firstFour"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M164 1.66667C164.635 1.66667 165.214 2.02679 165.495 2.59563L170.257 12.2441L180.908 13.8009C181.536 13.8926 182.057 14.3326 182.252 14.9359C182.448 15.5393 182.284 16.2014 181.83 16.6439L174.125 24.1489L175.943 34.7516C176.05 35.3769 175.793 36.0089 175.28 36.3818C174.767 36.7546 174.086 36.8038 173.525 36.5085L164 31.4997L154.476 36.5085C153.915 36.8038 153.234 36.7546 152.721 36.3818C152.208 36.0089 151.95 35.3769 152.058 34.7516L153.876 24.1489L146.171 16.6439C145.716 16.2014 145.553 15.5393 145.748 14.9359C145.944 14.3326 146.465 13.8926 147.093 13.8009L157.743 12.2441L162.506 2.59563C162.787 2.02679 163.366 1.66667 164 1.66667Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectFirstFive"
              id="firstFive"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M212 1.66667C212.635 1.66667 213.214 2.02679 213.495 2.59563L218.257 12.2441L228.908 13.8009C229.536 13.8926 230.057 14.3326 230.252 14.9359C230.448 15.5393 230.284 16.2014 229.83 16.6439L222.125 24.1489L223.943 34.7516C224.05 35.3769 223.793 36.0089 223.28 36.3818C222.767 36.7546 222.086 36.8038 221.525 36.5085L212 31.4997L202.476 36.5085C201.915 36.8038 201.234 36.7546 200.721 36.3818C200.208 36.0089 199.95 35.3769 200.058 34.7516L201.876 24.1489L194.171 16.6439C193.716 16.2014 193.553 15.5393 193.748 14.9359C193.944 14.3326 194.465 13.8926 195.093 13.8009L205.743 12.2441L210.506 2.59563C210.787 2.02679 211.366 1.66667 212 1.66667Z"
              fill="#B3C2CB"
            />
          </svg>
        </div>
        <div class="rating-box">
          <h5>
            How was your overall Session with {{ session.user.firstname }}?
          </h5>
          <svg
            width="233"
            height="40"
            viewBox="0 0 233 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              @click="selectSecondOne"
              id="secondOne"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.5004 1.66666C21.1347 1.66666 21.7141 2.02678 21.9949 2.59562L26.7575 12.2441L37.4081 13.8009C38.0357 13.8926 38.5568 14.3326 38.7524 14.9359C38.9481 15.5393 38.7843 16.2014 38.3299 16.6439L30.6246 24.1489L32.4431 34.7516C32.5503 35.3769 32.2932 36.0089 31.7799 36.3818C31.2666 36.7546 30.5861 36.8038 30.0246 36.5085L20.5004 31.4997L10.9761 36.5085C10.4146 36.8038 9.73411 36.7546 9.22082 36.3818C8.70752 36.0089 8.45045 35.3769 8.55769 34.7516L10.3762 24.1489L2.67082 16.6439C2.21646 16.2014 2.05267 15.5393 2.2483 14.9359C2.44393 14.3326 2.96506 13.8926 3.59266 13.8009L14.2433 12.2441L19.0059 2.59562C19.2866 2.02678 19.866 1.66666 20.5004 1.66666Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectSecondTwo"
              id="secondTwo"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M68.5004 1.66666C69.1347 1.66666 69.7141 2.02678 69.9949 2.59562L74.7575 12.2441L85.4081 13.8009C86.0357 13.8926 86.5568 14.3326 86.7524 14.9359C86.9481 15.5393 86.7843 16.2014 86.3299 16.6439L78.6246 24.1489L80.4431 34.7516C80.5503 35.3769 80.2932 36.0089 79.7799 36.3818C79.2666 36.7546 78.5861 36.8038 78.0246 36.5085L68.5004 31.4997L58.9761 36.5085C58.4146 36.8038 57.7341 36.7546 57.2208 36.3818C56.7075 36.0089 56.4504 35.3769 56.5577 34.7516L58.3762 24.1489L50.6708 16.6439C50.2165 16.2014 50.0527 15.5393 50.2483 14.9359C50.4439 14.3326 50.9651 13.8926 51.5927 13.8009L62.2433 12.2441L67.0059 2.59562C67.2866 2.02678 67.866 1.66666 68.5004 1.66666Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectSecondThree"
              id="secondThree"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M116.5 1.66666C117.135 1.66666 117.714 2.02678 117.995 2.59562L122.757 12.2441L133.408 13.8009C134.036 13.8926 134.557 14.3326 134.752 14.9359C134.948 15.5393 134.784 16.2014 134.33 16.6439L126.625 24.1489L128.443 34.7516C128.55 35.3769 128.293 36.0089 127.78 36.3818C127.267 36.7546 126.586 36.8038 126.025 36.5085L116.5 31.4997L106.976 36.5085C106.415 36.8038 105.734 36.7546 105.221 36.3818C104.708 36.0089 104.45 35.3769 104.558 34.7516L106.376 24.1489L98.6708 16.6439C98.2165 16.2014 98.0527 15.5393 98.2483 14.9359C98.4439 14.3326 98.9651 13.8926 99.5927 13.8009L110.243 12.2441L115.006 2.59562C115.287 2.02678 115.866 1.66666 116.5 1.66666Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectSecondFour"
              id="secondFour"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M164.5 1.66666C165.135 1.66666 165.714 2.02678 165.995 2.59562L170.757 12.2441L181.408 13.8009C182.036 13.8926 182.557 14.3326 182.752 14.9359C182.948 15.5393 182.784 16.2014 182.33 16.6439L174.625 24.1489L176.443 34.7516C176.55 35.3769 176.293 36.0089 175.78 36.3818C175.267 36.7546 174.586 36.8038 174.025 36.5085L164.5 31.4997L154.976 36.5085C154.415 36.8038 153.734 36.7546 153.221 36.3818C152.708 36.0089 152.45 35.3769 152.558 34.7516L154.376 24.1489L146.671 16.6439C146.216 16.2014 146.053 15.5393 146.248 14.9359C146.444 14.3326 146.965 13.8926 147.593 13.8009L158.243 12.2441L163.006 2.59562C163.287 2.02678 163.866 1.66666 164.5 1.66666Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectSecondFive"
              id="secondFive"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M212.5 1.66666C213.135 1.66666 213.714 2.02678 213.995 2.59562L218.757 12.2441L229.408 13.8009C230.036 13.8926 230.557 14.3326 230.752 14.9359C230.948 15.5393 230.784 16.2014 230.33 16.6439L222.625 24.1489L224.443 34.7516C224.55 35.3769 224.293 36.0089 223.78 36.3818C223.267 36.7546 222.586 36.8038 222.025 36.5085L212.5 31.4997L202.976 36.5085C202.415 36.8038 201.734 36.7546 201.221 36.3818C200.708 36.0089 200.45 35.3769 200.558 34.7516L202.376 24.1489L194.671 16.6439C194.216 16.2014 194.053 15.5393 194.248 14.9359C194.444 14.3326 194.965 13.8926 195.593 13.8009L206.243 12.2441L211.006 2.59562C211.287 2.02678 211.866 1.66666 212.5 1.66666Z"
              fill="#B3C2CB"
            />
          </svg>
        </div>
        <div class="rating-box">
          <h5>
            Would you recommend a Session with {{ session.user.firstname }} to
            your friends?
          </h5>
          <svg
            width="233"
            height="40"
            viewBox="0 0 233 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              @click="selectThirdOne"
              id="thirdOne"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.5004 1.66666C21.1347 1.66666 21.7141 2.02678 21.9949 2.59562L26.7575 12.2441L37.4081 13.8009C38.0357 13.8926 38.5568 14.3326 38.7524 14.9359C38.9481 15.5393 38.7843 16.2014 38.3299 16.6439L30.6246 24.1489L32.4431 34.7516C32.5503 35.3769 32.2932 36.0089 31.7799 36.3818C31.2666 36.7546 30.5861 36.8038 30.0246 36.5085L20.5004 31.4997L10.9761 36.5085C10.4146 36.8038 9.73411 36.7546 9.22082 36.3818C8.70752 36.0089 8.45045 35.3769 8.55769 34.7516L10.3762 24.1489L2.67082 16.6439C2.21646 16.2014 2.05267 15.5393 2.2483 14.9359C2.44393 14.3326 2.96506 13.8926 3.59266 13.8009L14.2433 12.2441L19.0059 2.59562C19.2866 2.02678 19.866 1.66666 20.5004 1.66666Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectThirdTwo"
              id="thirdTwo"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M68.5004 1.66666C69.1347 1.66666 69.7141 2.02678 69.9949 2.59562L74.7575 12.2441L85.4081 13.8009C86.0357 13.8926 86.5568 14.3326 86.7524 14.9359C86.9481 15.5393 86.7843 16.2014 86.3299 16.6439L78.6246 24.1489L80.4431 34.7516C80.5503 35.3769 80.2932 36.0089 79.7799 36.3818C79.2666 36.7546 78.5861 36.8038 78.0246 36.5085L68.5004 31.4997L58.9761 36.5085C58.4146 36.8038 57.7341 36.7546 57.2208 36.3818C56.7075 36.0089 56.4504 35.3769 56.5577 34.7516L58.3762 24.1489L50.6708 16.6439C50.2165 16.2014 50.0527 15.5393 50.2483 14.9359C50.4439 14.3326 50.9651 13.8926 51.5927 13.8009L62.2433 12.2441L67.0059 2.59562C67.2866 2.02678 67.866 1.66666 68.5004 1.66666Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectThirdThree"
              id="thirdThree"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M116.5 1.66666C117.135 1.66666 117.714 2.02678 117.995 2.59562L122.757 12.2441L133.408 13.8009C134.036 13.8926 134.557 14.3326 134.752 14.9359C134.948 15.5393 134.784 16.2014 134.33 16.6439L126.625 24.1489L128.443 34.7516C128.55 35.3769 128.293 36.0089 127.78 36.3818C127.267 36.7546 126.586 36.8038 126.025 36.5085L116.5 31.4997L106.976 36.5085C106.415 36.8038 105.734 36.7546 105.221 36.3818C104.708 36.0089 104.45 35.3769 104.558 34.7516L106.376 24.1489L98.6708 16.6439C98.2165 16.2014 98.0527 15.5393 98.2483 14.9359C98.4439 14.3326 98.9651 13.8926 99.5927 13.8009L110.243 12.2441L115.006 2.59562C115.287 2.02678 115.866 1.66666 116.5 1.66666Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectThirdFour"
              id="thirdFour"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M164.5 1.66666C165.135 1.66666 165.714 2.02678 165.995 2.59562L170.757 12.2441L181.408 13.8009C182.036 13.8926 182.557 14.3326 182.752 14.9359C182.948 15.5393 182.784 16.2014 182.33 16.6439L174.625 24.1489L176.443 34.7516C176.55 35.3769 176.293 36.0089 175.78 36.3818C175.267 36.7546 174.586 36.8038 174.025 36.5085L164.5 31.4997L154.976 36.5085C154.415 36.8038 153.734 36.7546 153.221 36.3818C152.708 36.0089 152.45 35.3769 152.558 34.7516L154.376 24.1489L146.671 16.6439C146.216 16.2014 146.053 15.5393 146.248 14.9359C146.444 14.3326 146.965 13.8926 147.593 13.8009L158.243 12.2441L163.006 2.59562C163.287 2.02678 163.866 1.66666 164.5 1.66666Z"
              fill="#B3C2CB"
            />
            <path
              @click="selectThirdFive"
              id="thirdFive"
              class="star"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M212.5 1.66666C213.135 1.66666 213.714 2.02678 213.995 2.59562L218.757 12.2441L229.408 13.8009C230.036 13.8926 230.557 14.3326 230.752 14.9359C230.948 15.5393 230.784 16.2014 230.33 16.6439L222.625 24.1489L224.443 34.7516C224.55 35.3769 224.293 36.0089 223.78 36.3818C223.267 36.7546 222.586 36.8038 222.025 36.5085L212.5 31.4997L202.976 36.5085C202.415 36.8038 201.734 36.7546 201.221 36.3818C200.708 36.0089 200.45 35.3769 200.558 34.7516L202.376 24.1489L194.671 16.6439C194.216 16.2014 194.053 15.5393 194.248 14.9359C194.444 14.3326 194.965 13.8926 195.593 13.8009L206.243 12.2441L211.006 2.59562C211.287 2.02678 211.866 1.66666 212.5 1.66666Z"
              fill="#B3C2CB"
            />
          </svg>
        </div>
      </div>
      <button
        v-if="!submitted"
        :disabled="!firstAnswer || !secondAnswer || !thirdAnswer"
        class="rejoin"
        @click="submitFeedback"
      >
        Submit Rating
      </button>
      <button class="rejoin" @click="backToLounge">
        Back to Lounge
      </button>
    </div>

    <div class="footer">
      <p>Copyright ©2019-2021 JourneyBinder. All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
import SessionNavbar from "../sessionNavbar";
export default {
  name: "SessionFeedback",
  data() {
    return {
      submitted: false,
      firstAnswer: null,
      secondAnswer: null,
      thirdAnswer: null
    };
  },
  props: {
    session: {
      type: Object,
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
  components: {
    SessionNavbar
  },
  methods: {
    rejoinSession() {
      this.$emit("rejoin-session", this.session);
    },
    backToLounge() {
      this.$emit("back-to-lounge");
    },
    selectFirstOne() {
      document.getElementById("firstOne").style.fill = "#EABA26";
      document.getElementById("firstTwo").style.fill = "#B3C2CB";
      document.getElementById("firstThree").style.fill = "#B3C2CB";
      document.getElementById("firstFour").style.fill = "#B3C2CB";
      document.getElementById("firstFive").style.fill = "#B3C2CB";
      this.firstAnswer = 1;
    },
    selectFirstTwo() {
      document.getElementById("firstOne").style.fill = "#EABA26";
      document.getElementById("firstTwo").style.fill = "#EABA26";
      document.getElementById("firstThree").style.fill = "#B3C2CB";
      document.getElementById("firstFour").style.fill = "#B3C2CB";
      document.getElementById("firstFive").style.fill = "#B3C2CB";
      this.firstAnswer = 2;
    },
    selectFirstThree() {
      document.getElementById("firstOne").style.fill = "#EABA26";
      document.getElementById("firstTwo").style.fill = "#EABA26";
      document.getElementById("firstThree").style.fill = "#EABA26";
      document.getElementById("firstFour").style.fill = "#B3C2CB";
      document.getElementById("firstFive").style.fill = "#B3C2CB";
      this.firstAnswer = 3;
    },
    selectFirstFour() {
      document.getElementById("firstOne").style.fill = "#EABA26";
      document.getElementById("firstTwo").style.fill = "#EABA26";
      document.getElementById("firstThree").style.fill = "#EABA26";
      document.getElementById("firstFour").style.fill = "#EABA26";
      document.getElementById("firstFive").style.fill = "#B3C2CB";
      this.firstAnswer = 4;
    },
    selectFirstFive() {
      document.getElementById("firstOne").style.fill = "#EABA26";
      document.getElementById("firstTwo").style.fill = "#EABA26";
      document.getElementById("firstThree").style.fill = "#EABA26";
      document.getElementById("firstFour").style.fill = "#EABA26";
      document.getElementById("firstFive").style.fill = "#EABA26";
      this.firstAnswer = 5;
    },
    selectSecondOne() {
      document.getElementById("secondOne").style.fill = "#EABA26";
      document.getElementById("secondTwo").style.fill = "#B3C2CB";
      document.getElementById("secondThree").style.fill = "#B3C2CB";
      document.getElementById("secondFour").style.fill = "#B3C2CB";
      document.getElementById("secondFive").style.fill = "#B3C2CB";
      this.secondAnswer = 1;
    },
    selectSecondTwo() {
      document.getElementById("secondOne").style.fill = "#EABA26";
      document.getElementById("secondTwo").style.fill = "#EABA26";
      document.getElementById("secondThree").style.fill = "#B3C2CB";
      document.getElementById("secondFour").style.fill = "#B3C2CB";
      document.getElementById("secondFive").style.fill = "#B3C2CB";
      this.secondAnswer = 2;
    },
    selectSecondThree() {
      document.getElementById("secondOne").style.fill = "#EABA26";
      document.getElementById("secondTwo").style.fill = "#EABA26";
      document.getElementById("secondThree").style.fill = "#EABA26";
      document.getElementById("secondFour").style.fill = "#B3C2CB";
      document.getElementById("secondFive").style.fill = "#B3C2CB";
      this.secondAnswer = 3;
    },
    selectSecondFour() {
      document.getElementById("secondOne").style.fill = "#EABA26";
      document.getElementById("secondTwo").style.fill = "#EABA26";
      document.getElementById("secondThree").style.fill = "#EABA26";
      document.getElementById("secondFour").style.fill = "#EABA26";
      document.getElementById("secondFive").style.fill = "#B3C2CB";
      this.secondAnswer = 4;
    },
    selectSecondFive() {
      document.getElementById("secondOne").style.fill = "#EABA26";
      document.getElementById("secondTwo").style.fill = "#EABA26";
      document.getElementById("secondThree").style.fill = "#EABA26";
      document.getElementById("secondFour").style.fill = "#EABA26";
      document.getElementById("secondFive").style.fill = "#EABA26";
      this.secondAnswer = 5;
    },
    selectThirdOne() {
      document.getElementById("thirdOne").style.fill = "#EABA26";
      document.getElementById("thirdTwo").style.fill = "#B3C2CB";
      document.getElementById("thirdThree").style.fill = "#B3C2CB";
      document.getElementById("thirdFour").style.fill = "#B3C2CB";
      document.getElementById("thirdFive").style.fill = "#B3C2CB";
      this.thirdAnswer = 1;
    },
    selectThirdTwo() {
      document.getElementById("thirdOne").style.fill = "#EABA26";
      document.getElementById("thirdTwo").style.fill = "#EABA26";
      document.getElementById("thirdThree").style.fill = "#B3C2CB";
      document.getElementById("thirdFour").style.fill = "#B3C2CB";
      document.getElementById("thirdFive").style.fill = "#B3C2CB";
      this.thirdAnswer = 2;
    },
    selectThirdThree() {
      document.getElementById("thirdOne").style.fill = "#EABA26";
      document.getElementById("thirdTwo").style.fill = "#EABA26";
      document.getElementById("thirdThree").style.fill = "#EABA26";
      document.getElementById("thirdFour").style.fill = "#B3C2CB";
      document.getElementById("thirdFive").style.fill = "#B3C2CB";
      this.thirdAnswer = 3;
    },
    selectThirdFour() {
      document.getElementById("thirdOne").style.fill = "#EABA26";
      document.getElementById("thirdTwo").style.fill = "#EABA26";
      document.getElementById("thirdThree").style.fill = "#EABA26";
      document.getElementById("thirdFour").style.fill = "#EABA26";
      document.getElementById("thirdFive").style.fill = "#B3C2CB";
      this.thirdAnswer = 4;
    },
    selectThirdFive() {
      document.getElementById("thirdOne").style.fill = "#EABA26";
      document.getElementById("thirdTwo").style.fill = "#EABA26";
      document.getElementById("thirdThree").style.fill = "#EABA26";
      document.getElementById("thirdFour").style.fill = "#EABA26";
      document.getElementById("thirdFive").style.fill = "#EABA26";
      this.thirdAnswer = 5;
    },
    submitFeedback() {
      console.log(this.firstAnswer);
      console.log(this.secondAnswer);
      console.log(this.thirdAnswer);
      this.submitted = true;

      let rating = {
        _created_at: new Date(),
        user: this.profile.firstname,
        guide: this.session.user.firstname,
        rating: {
          AudioVideo: this.firstAnswer,
          OverallSession: this.secondAnswer,
          recommendation: this.thirdAnswer
        }
      };
      this.$emit("submit-feedback", rating, this.session.room_id);
    }
  }
};
</script>

<style lang="scss" scoped>
.left {
  background: #f3f6f9;
  min-height: calc(100vh);
  min-width: calc(100vw);
  .content-left {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .title {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 48px;
      line-height: 65px;
      display: flex;
      align-items: center;
      color: #000000;
    }
    .star {
      cursor: pointer;
    }
  }
  .rejoin {
    margin: 10px 0;
    min-width: 466px;
    height: 83px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #ffffff;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    color: var(--theme-color);
    transition: all 0.2s ease-in-out;
    svg {
      margin-right: 10px;
    }
    &:hover {
      box-shadow: 0px 0px 8px 0px #b1b1b1;
    }
  }
  .rating {
    background-color: #fff;
    margin: 10px 0;
    max-width: 466px;
    border-radius: 8px;
    border: 1px solid #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 30px;
    .rating-box {
      margin: 20px 0;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 27px;
      display: flex;
      align-items: center;
      flex-direction: column;
      color: #474d52;
      h5 {
        text-align: center;
      }
    }
  }
  .footer {
    text-align: center;
  }
}
@media (max-width: 560px) {
  .title {
    text-align: center;
    font-size: 22px !important;
  }
  .rejoin,
  .rating {
    min-width: 90% !important;
    max-width: 90% !important;
  }
}
</style>
